import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import {takeUntil, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {GoogleAnalyticsIntegrationService} from '@synisys/ejustice-controls/src/app/pages/administration/integrations/google/analytics/google-analytics-integration.service';

declare let gtag: Function;

@Component({
	selector: 'sis-app',
	template: require('./app.component.html')
})
export class AppComponent implements OnInit, OnDestroy {

	private static addGAScript(gaTrackingId: string): void {
		const gtagScript: HTMLScriptElement = document.createElement('script');
		gtagScript.async = true;
		gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + gaTrackingId;
		document.head.appendChild(gtagScript);
		// Disable automatic page view hit to fix duplicate page view count
		gtag('config', gaTrackingId, {send_page_view: false});
	}

	private readonly _destroy$ = new Subject<void>();

	constructor(public readonly router: Router,
				private readonly googleAnalyticsIntegrationService: GoogleAnalyticsIntegrationService) {
	}

	public ngOnDestroy(): void {
		this._destroy$.next();
		this._destroy$.complete();
	}

	public ngOnInit(): void {
		this.configureGA();
	}

	private configureGA(): void {
		this.googleAnalyticsIntegrationService.loadGoogleAnalyticsConfig()
			.pipe(
				switchMap(analyticsConfig => {
					if (!!analyticsConfig.key) {
						AppComponent.addGAScript(analyticsConfig.key);
						return this.router.events;
					}
					return of(null);
				}),
				takeUntil(this._destroy$))
			.subscribe(event => {
				if (event instanceof NavigationEnd) {
					gtag('event', 'page_view', {
						page_path: event.urlAfterRedirects
					});
				}
			});
	}
}
